(function () {
  function boot() {
    var rail = document.querySelector('[data-rail]');
    if (!rail || rail.getAttribute('data-rail-ready')) return;
    rail.setAttribute('data-rail-ready', '1');
    var track = rail.querySelector('.rail__track');
    if (!track) return;
    var slides = Array.prototype.slice.call(track.children);
    var dotsWrap = rail.querySelector('[data-rail-dots]');
    var prev = rail.querySelector('[data-rail-prev]');
    var next = rail.querySelector('[data-rail-next]');
    if (!slides.length || !dotsWrap) return;

    dotsWrap.innerHTML = '';
    slides.forEach(function (_, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('aria-label', 'Slide ' + (i + 1));
      b.addEventListener('click', function () { goTo(i); });
      dotsWrap.appendChild(b);
    });
    var dots = dotsWrap.querySelectorAll('button');

    function slideCenter(i) {
      return slides[i].offsetLeft + slides[i].offsetWidth / 2;
    }
    function currentIndex() {
      var mid = track.scrollLeft + track.clientWidth / 2;
      var best = 0;
      var dist = Infinity;
      slides.forEach(function (_, i) {
        var d = Math.abs(slideCenter(i) - mid);
        if (d < dist) { dist = d; best = i; }
      });
      return best;
    }
    function scrollToIndex(i, smooth) {
      i = Math.min(slides.length - 1, Math.max(0, i));
      var left = slideCenter(i) - track.clientWidth / 2;
      track.scrollTo({ left: Math.max(0, left), behavior: smooth ? 'smooth' : 'auto' });
    }
    function goTo(i) { scrollToIndex(i, true); }
    function go(dir) { goTo(currentIndex() + dir); }
    function paint() {
      var i = currentIndex();
      dots.forEach(function (d, n) { d.classList.toggle('is-on', n === i); });
    }
    track.addEventListener('scroll', paint, { passive: true });
    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });
    paint();

    var drag = { on: false, startX: 0, startLeft: 0, moved: false, pid: null };
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      drag.on = true;
      drag.moved = false;
      drag.startX = e.clientX;
      drag.startLeft = track.scrollLeft;
      drag.pid = e.pointerId;
      track.classList.add('is-dragging');
      try { track.setPointerCapture(e.pointerId); } catch (err) {}
    });
    track.addEventListener('pointermove', function (e) {
      if (!drag.on || e.pointerId !== drag.pid) return;
      var dx = e.clientX - drag.startX;
      if (Math.abs(dx) > 8) drag.moved = true;
      if (drag.moved) {
        track.scrollLeft = drag.startLeft - dx;
        if (e.cancelable) e.preventDefault();
      }
    }, { passive: false });
    function endDrag(e) {
      if (!drag.on || (e && e.pointerId !== drag.pid)) return;
      drag.on = false;
      track.classList.remove('is-dragging');
      try { track.releasePointerCapture(drag.pid); } catch (err) {}
      if (drag.moved) scrollToIndex(currentIndex(), true);
      drag.pid = null;
    }
    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);
    track.addEventListener('click', function (e) {
      if (drag.moved) {
        e.preventDefault();
        e.stopPropagation();
        drag.moved = false;
      }
    }, true);

    if (window.matchMedia('(max-width: 899px)').matches) {
      window.setTimeout(function () {
        if (track.scrollLeft > 8) return;
        scrollToIndex(0, false);
      }, 120);
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
